import { render, staticRenderFns } from "./uploadWorks.vue?vue&type=template&id=6c6ac205&scoped=true"
import script from "./uploadWorks.vue?vue&type=script&lang=js"
export * from "./uploadWorks.vue?vue&type=script&lang=js"
import style0 from "./uploadWorks.vue?vue&type=style&index=0&id=6c6ac205&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6ac205",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c6ac205')) {
      api.createRecord('6c6ac205', component.options)
    } else {
      api.reload('6c6ac205', component.options)
    }
    module.hot.accept("./uploadWorks.vue?vue&type=template&id=6c6ac205&scoped=true", function () {
      api.rerender('6c6ac205', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/player/uploadWorks.vue"
export default component.exports